/**
 * 简单密码认证（无后端依赖）
 *
 * 原理：
 * - 登录密码 SHA-256 哈希后与预设值比较（不可逆）
 * - 登录成功 → sessionStorage 存标记
 * - 页面刷新 → 从 sessionStorage 恢复登录态
 * - 关闭标签页/浏览器 → 自动失效
 *
 * 密码修改方法：改下方 PASS_HASH 常量即可
 * 生成哈希（浏览器控制台）：btoa(await crypto.subtle.digest('SHA-256', new TextEncoder().encode('your_password')))
 */

const SESSION_KEY = 'dj95_session'
const PASS_HASH = 'JAvm0r2yTqF8oK3pN5xL7uW1cB4dH6jR9kM2vS5eX8zA0bG3fI6nT' // 占位，需要替换

// 预设密码 dj951995 的 SHA-256 哈希
// 修改密码：浏览器控制台运行 → btoa(await crypto.subtle.digest('SHA-256', new TextEncoder().encode('你的密码')))
const VALID_HASH = '5a07fd19dc486b1894fea8b92bb34fa6ed773f172d121cc911aab8d2e94c5f1d'

/**
 * 简单哈希（浏览器内 SHA-256 → base64）
 */
async function hashPassword(password) {
  const encoder = new TextEncoder()
  const data = encoder.encode(password)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}

/**
 * 验证密码，返回 true/false
 */
export async function verifyPassword(password) {
  const inputHash = await hashPassword(password)
  return inputHash === VALID_HASH
}

/**
 * 登录
 */
export async function login(password) {
  const ok = await verifyPassword(password)
  if (ok) {
    sessionStorage.setItem(SESSION_KEY, '1')
    return true
  }
  return false
}

/**
 * 登出
 */
export function logout() {
  sessionStorage.removeItem(SESSION_KEY)
}

/**
 * 检查是否已登录
 */
export function isLoggedIn() {
  return sessionStorage.getItem(SESSION_KEY) === '1'
}

/**
 * 获取 sessionStorage 中的登录标记（供 router 等直接调用）
 */
export function checkAuth() {
  return isLoggedIn()
}
